import { parseTemplate } from 'url-template';
import { mapProductIdPrice, ProductIdPrice } from '~/Api/ProductPrice';
import ApiClient from '~/ApiClient';

const MaxProductIdsCount = 50;

export interface Result {
	items: ProductIdPrice[];
}

export default function findProductPrices(
	client: ApiClient,
	userId: string,
	groupId: string,
	currency: string | null,
	productIds: string[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/products-prices{?currency,productIds}');

	const batchesCount = Math.ceil(productIds.length / MaxProductIdsCount);
	const requests = Array(batchesCount)
		.fill(null)
		.map((foo, i) => {
			const batchProductIds = productIds.slice(i * MaxProductIdsCount, i * MaxProductIdsCount + MaxProductIdsCount);

			return client
				.fetch(
					url.expand({
						userId,
						groupId,
						currency,
						productIds: batchProductIds.join(','),
					})
				)
				.then((response) => response.json());
		});

	return Promise.all(requests).then((responses) => ({
		items: responses.reduce((items, response) => [...items, ...response.items.map(mapProductIdPrice)], []),
	}));
}
